<template>
    <div class="wrap">
      <div class="nav_bar">
        <van-icon
          name="arrow-left"
          size="20"
          style="position: absolute; left: 18px; top: 24px"
          @click="onClickLeft"
          v-show="!backIcon"
        />
        <span style="font-size: 20px; color: #323233; font-weight: bold">
            手术申请
        </span>
      </div>
      <div class="record" @click="func()">申请记录</div>
      <van-form ref="formalidate" v-model="form">
        <van-cell-group>
          <van-field v-model="form.patientCardNo" label="病人ID" placeholder="请输入病人ID" />
          <van-field v-model="form.inHospitalNo" label="住院号" placeholder="请输入住院号" />
          <van-field v-model="form.patientName" label="姓名" placeholder="请输入姓名" />
          <van-field v-model="form.patientSex" label="性别" placeholder="请输入性别" />
          <van-field v-model="form.patientAge" label="年龄" placeholder="请输入年龄" />
          <van-field v-model="form.patientInDept" label="所在科室" placeholder="请输入所在科室" />
          <van-field v-model="form.bedNo" label="床号" placeholder="请输入床号" />
          <van-field v-model="form.mianDiagnosis" label="主要诊断" placeholder="请输入主要诊断" />
          <van-field v-model="form.illnessIntroduced" label="病情" placeholder="请输入病情" />
          <van-field v-model="form.implementOperation" label="拟实施手术" placeholder="请输入拟实施手术" />
          <van-field v-model="form.grade" label="等级" placeholder="请输入等级" />
          <!-- <van-field v-model="form.operationTime" label="手术日期" placeholder="请输入手术日期" /> -->
          <van-field
          v-model="form.operationTime"
          is-link
          readonly
          name="calendar"
          label="手术日期"
          placeholder="点击手术日期"
          @click="showCalendar = true"
          />
          <van-calendar v-model:show="showCalendar" @confirm="onConfirm" />
          <van-field v-model="form.operationRoomNo" label="手术间号" placeholder="请输入手术间号" />
          <van-field v-model="form.stationsNo" label="台次" placeholder="请输入台次" />
          <van-field v-model="form.operationGrade" label="手术等级" placeholder="请输入手术等级" />
          <van-field v-model="form.quarantine" label="隔离" placeholder="请输入隔离" />
          <van-field v-model="form.emergency" label="急诊" placeholder="请输入急诊" />
          <van-field v-model="form.deptName" label="科室" placeholder="请输入科室" />
          <van-field v-model="form.operationDoctor" label="手术医师" placeholder="请输入手术医师" />
          <van-field v-model="form.assistant" label="助手" placeholder="请输入助手" />
          <van-field v-model="form.anesthesiaMethod" label="麻醉方法" placeholder="请输入麻醉方法" />
          <van-field v-model="form.anesthesiaDoctor" label="麻醉医师" placeholder="请输入麻醉医师" />
          <van-field v-model="form.metachysisDoctor" label="输血医师" placeholder="请输入输血医师" />
          <van-field v-model="form.stageNurses" label="台上护士" placeholder="请输入台上护士" />
          <van-field v-model="form.supplyNurses" label="供应护士" placeholder="请输入供应护士" />
          <van-field v-model="form.remark" label="备注" placeholder="请输入备注" />
        </van-cell-group>
      </van-form>
      <div class="btn" @click="goInfo()">确定</div>
    </div>
  </template>
  <script>
  import { Toast } from "vant";
  import { surgerySave } from "@/api/surgery";
  export default {
    data() {
      return {
        active: 1,
        dateValue: "",
        visitId: "",
        cardNo: "",
        form: {},
        repeatIndicator: "",
        backIcon: localStorage.getItem("routerHistory"),
        showCalendar: false,
      };
    },
    methods: {
      onClickLeft() {
        this.$router.push({ path: "/menu" });
      },
      func(){
        this.$router.replace("/record");
      },
      goInfo() {
        surgerySave(this.form).then((res) => {
          if (res.data.code == "200") {
            this.form = {};
            this.$toast("申请成功");
          }
        });
      },
      onConfirm(value) {
        let date = new Date(value)
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        m = m < 10 ? ('0' + m) : m
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        const time =  y + '-' + m + '-' + d;
        this.form.operationTime = time;
        this.showCalendar = false;
      },
    },
  };
  </script>
  <style lang="less" scoped>

  .wrap {
    padding-top: 20px;
    .btn {
      width: 90%;
      height: 40px;
      margin: 0 auto 15px;
      background: #1578f9;
      font-size: 18px;
      border-radius: 23px 23px 23px 23px;
      font-weight: bold;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
    }
    .nav_bar {
      text-align: center;
      color: #323233;
    }
  }
  
  /deep/.van-cell-group {
    margin: 16px;
    border-radius: 10px;
  }
  
  /deep/.van-cell {
    border-radius: 10px;
  }
  .record{
    width: 90%;
    margin: 15px auto;
    text-align: right;
    color: #409EFF;
  }
  </style>
  